// src/components/Layout.jsx
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import Sidebar from './Sidebar';
import Header from './Header';
import '../styles/Layout.css';
import logo from '../assets/Kuddlecore-Logo.png';
import '../styles/Theme.css';


const Layout = () => {
  const { theme } = useTheme();
  const location = useLocation(); // ✅ Get current route  
  const hideMainSidebar = location.pathname === "/messages";


  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
  }, [theme]);

  return (
    <div className="layout-container">
      {!hideMainSidebar && <Sidebar />}

      <main
        className={`main-content ${hideMainSidebar ? "messages-full-page" : ""
          }`}
      >
        <Header />

        <div className={`content ${hideMainSidebar ? "messages-content-reset" : ""}`}>
          <Outlet />
        </div>

        <footer className="footer">
          <div className="footer-content">
            <img src={logo} alt="Kuddlecore Logo" className="footer-logo" />
            <p className="tagline">Simplify Your Day. Amplify Their Future.</p>
            <p className="copyright">
              &copy; {new Date().getFullYear()} Kuddlecore Solutions, LLC
            </p>
          </div>
        </footer>

      </main>
    </div>
  );
};

export default Layout;
